import React from 'react';
import { Section } from './ui/Section';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  return <Section background="cream" className="border-y border-[#1B4332]/10" data-id="element-1">
      <div className="grid md:grid-cols-2 gap-6 md:gap-10" data-id="element-2">
        {/* For You */}
        <div className="bg-white p-6 rounded-2xl shadow-sm border-t-4 border-[#1B4332]" data-id="element-3">
          <h3 className="text-2xl font-bold mb-4 flex items-center gap-3" data-id="element-4">
            <span className="bg-[#1B4332] text-white p-1 rounded-full" data-id="element-5">
              <Check className="w-4 h-4" data-id="element-6" />
            </span>
            Esto es para vos si...
          </h3>
          <ul className="space-y-3" data-id="element-7">
            {['Querés opciones naturales porque no querés empastillarte por todo.', 'Pero también querés seguridad, porque no estás para improvisar.', 'Te cansaste de buscar y encontrar 30 respuestas distintas.', 'Tenés poco tiempo y necesitás decidir rápido (para vos o tu familia).'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-700" data-id="element-8">
                <Check className="w-5 h-5 text-[#1B4332] mt-0.5 flex-shrink-0" data-id="element-9" />
                <span data-id="element-10">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Not For You */}
        <div className="bg-white p-6 rounded-2xl shadow-sm border-t-4 border-[#EF4444]" data-id="element-11">
          <h3 className="text-2xl font-bold mb-4 flex items-center gap-3 text-gray-800" data-id="element-12">
            <span className="bg-[#EF4444] text-white p-1 rounded-full" data-id="element-13">
              <X className="w-4 h-4" data-id="element-14" />
            </span>
            Esto NO es para vos si...
          </h3>
          <ul className="space-y-3" data-id="element-15">
            {["Estás buscando 'curas milagrosas' o mágicas.", 'Querés reemplazar tratamientos médicos indicados.', "Te molesta que alguien te diga 'hasta acá sí, a partir de acá no'."].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-700" data-id="element-16">
                <X className="w-5 h-5 text-[#EF4444] mt-0.5 flex-shrink-0" data-id="element-17" />
                <span data-id="element-18">{item}</span>
              </li>)}
          </ul>
          <div className="mt-6 pt-4 border-t border-gray-100" data-id="element-19">
            <p className="text-center font-medium text-gray-600" data-id="element-20">
              Porque este botiquín tiene una idea clara: <br data-id="element-21" />
              <span className="text-[#1B4332] font-bold" data-id="element-22">
                aliviar sin tapar señales importantes.
              </span>
            </p>
          </div>
        </div>
      </div>
    </Section>;
}